import { apiUrl, currentUserId, currentUserQuery, suiteRoot } from "./auth";

export type RdvType = { id: string; title: string; ownerId: number };

async function rdv(path: string, body?: unknown): Promise<Record<string, unknown>> {
  const headers = new Headers();
  const userId = currentUserId();
  if (userId) headers.set("X-User-Id", userId);
  if (body) headers.set("Content-Type", "application/json");
  const res = await fetch(`${suiteRoot()}/api_suite/${path}`, {
    method: body ? "POST" : "GET",
    credentials: "include",
    cache: "no-store",
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (res.status === 403) throw new Error("Mes RDV n’est pas ouvert pour ce compte.");
  if (!res.ok || data.success === false) {
    throw new Error(String(data.message || "Mes RDV ne répond pas."));
  }
  return data;
}

export async function listRdvTypes(): Promise<RdvType[]> {
  const data = await rdv("rdv-data.php");
  const rows = Array.isArray(data.eventTypes) ? data.eventTypes : [];
  return rows.flatMap((row) => {
    const item = row as { id?: string; title?: string; kind?: string; active?: boolean; ownerUserId?: number; owner_user_id?: number };
    if (item.kind !== "appointment" || item.active === false || !item.id) return [];
    const ownerId = Number(item.ownerUserId || item.owner_user_id) || Number(currentUserId()) || 0;
    return [{ id: String(item.id), title: item.title || "Rendez-vous", ownerId }];
  });
}

export type RdvOpening = { days: { key: string }[]; day: string; slots: string[] };

export async function listRdvOpenings(ownerId: number, eventTypeId: string, day?: string): Promise<RdvOpening> {
  const query = new URLSearchParams({ owner: String(ownerId), event_type: eventTypeId });
  if (day) query.set("day", day);
  const data = await rdv(`rdv-public-data.php?${query}`);
  const days = Array.isArray(data.dayOptions) ? data.dayOptions.flatMap((row) => {
    const key = String((row as { key?: string }).key || "");
    return key ? [{ key }] : [];
  }) : [];
  const slots = Array.isArray(data.slots) ? data.slots.map((slot) => String(slot)) : [];
  return { days, day: String(data.day || day || days[0]?.key || ""), slots };
}

export async function openRdvOffer(input: { ownerId: number; eventTypeId: string; who: string; email: string; what: string; startsAt: string }): Promise<string> {
  const res = await fetch(apiUrl("rdv-offer.php") + currentUserQuery(), {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: { "Content-Type": "application/json", ...(currentUserId() ? { "X-User-Id": currentUserId() } : {}) },
    body: JSON.stringify(input),
  });
  const data = (await res.json().catch(() => ({}))) as { success?: boolean; message?: string; url?: string };
  if (!res.ok || data.success === false || !data.url) {
    throw new Error(data.message || "La proposition n’a pas été préparée.");
  }
  return data.url;
}
